// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1Ja1f","alert":"SettungsInbox_alert__2FaYQ"};